/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal, Loader, Table } from 'semantic-ui-react';

import styles from './AlertDataModal.module.scss';

const AlertDataModal = React.memo(({ alert, open, onClose }) => {
  const [t] = useTranslation();

  const handleCloseModal = () => {
    onClose(false);
  };

  return (
    <Modal closeIcon size="small" open={open} onClose={handleCloseModal}>
      <Modal.Header>{t('common.alertData')}</Modal.Header>
      <Modal.Content>
        {alert?.isDataFetching ? (
          <Loader active size="massive" />
        ) : (
          alert && (
            <div className={styles.detailWrapper}>
              <div className={styles.alertDetail}>
                {alert.device && alert.device.name} - {alert.item && alert.item.name} -
                {alert.alertSetting && alert.alertSetting.name}
              </div>
              <Table singleLine>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell className="uppercase text-xs text-grey">
                      {t('common.alerts.day')}
                    </Table.HeaderCell>
                    <Table.HeaderCell className="uppercase text-xs text-grey">
                      {t('common.alerts.time')}
                    </Table.HeaderCell>
                    <Table.HeaderCell className="uppercase text-xs text-grey">
                      {t('common.alerts.value')}
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {alert?.alertDatas?.map((data) => {
                    return (
                      <Table.Row className={styles.alertItem} key={data.loggedAt}>
                        <Table.Cell>
                          <span className={styles.loggedAt}>
                            {t('format:date', {
                              postProcess: 'formatDate',
                              value: new Date(data.loggedAt),
                            })}
                          </span>
                        </Table.Cell>
                        <Table.Cell>
                          <span className={styles.loggedAt}>
                            {t('format:time', {
                              postProcess: 'formatDate',
                              value: new Date(data.loggedAt),
                            })}
                          </span>
                        </Table.Cell>
                        <Table.Cell>
                          {data[alert.item.itemName].toLocaleString('en-GB', {
                            minimumFractionDigits: alert.item.decimalPoint,
                            maximumFractionDigits: alert.item.decimalPoint,
                          })}
                        </Table.Cell>
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>
            </div>
          )
        )}
      </Modal.Content>
    </Modal>
  );
});

AlertDataModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  alert: PropTypes.objectOf(PropTypes.any),
};

AlertDataModal.defaultProps = {
  alert: null,
};

export default AlertDataModal;
